import { axiosBackendInstance } from '../axiosInstance'

export const createVerificationSession = async () => {
  return axiosBackendInstance.post('/api/v1/stripe/create-verification-session')
}
